// @core/api/endpoints/landing/create_landing_page.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateLandingPageRequest,
  LandingPageResponse,
} from '../../../types/landing';

const BASE_PATH = '/landing';

/**
 * Create a new landing page
 * Creates a new landing page in draft status. Add sections after creation.
 */
export async function CreateLandingPage(
  data: CreateLandingPageRequest,
  options?: RequestOptions
): Promise<LandingPageResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/landing/pages`;
  const requestOptions = options;
  return client.post<LandingPageResponse>(requestPath, data, requestOptions);
}
